import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withWidth } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import ToFrontIcon from '../Resources/Icons/ToFrontIcon';
import ToBackIcon from '../Resources/Icons/ToBackIcon';
import HorizontalIcon from '../Resources/Icons/HorizontalIcon';
import VerticalIcon from '../Resources/Icons/VerticalIcon';

const styles = (theme) => ({
  toolButtonPositioning: {
    width: 40,
    height: 40,
    minWidth: 35,
    minHeight: 35,
    margin: '0px 8px 0 0',
    [theme.breakpoints.down('xs')]: {
      margin: '0px 5px 0 0',
    },
    '& .MuiButton-outlined': {
      padding: '0 !important',
    },
  },
});

class ObjectTools extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    handleButtonClick: PropTypes.func,
    handleObjectButtonClick: PropTypes.func,
    flipToBackDisabled: PropTypes.bool,
    flipToFrontDisabled: PropTypes.bool,
  };

  render() {
    const { classes, handleObjectButtonClick, flipToBackDisabled, flipToFrontDisabled } = this.props;

    return (
      <React.Fragment>
        <AnalyticsWrapper targetId="align_vertical_center">
          <Button
            className={classes.toolButtonPositioning + ' object-btn'}
            variant="outlined"
            value="alignVerticalCenter"
            onClick={handleObjectButtonClick}
          >
            <Tooltip title={t('objectTools.alignVerticalCenter')}>
              <VerticalIcon />
            </Tooltip>
          </Button>
        </AnalyticsWrapper>
        <AnalyticsWrapper targetId="align_horizontal_center">
          <Button
            className={classes.toolButtonPositioning + ' object-btn'}
            variant="outlined"
            value="alignHorizontalCenter"
            onClick={handleObjectButtonClick}
          >
            <Tooltip title={t('objectTools.alignHorizontalCenter')}>
              <HorizontalIcon />
            </Tooltip>
          </Button>
        </AnalyticsWrapper>
        <AnalyticsWrapper targetId="align_move_down">
          <Button
            className={classes.toolButtonPositioning + ' object-btn'}
            variant="outlined"
            value="moveDown"
            onClick={handleObjectButtonClick}
            disabled={flipToBackDisabled}
          >
            <Tooltip title={t('objectTools.moveDown')}>
              <ToBackIcon />
            </Tooltip>
          </Button>
        </AnalyticsWrapper>
        <AnalyticsWrapper targetId="align_move_up">
          <Button
            className={classes.toolButtonPositioning + ' object-btn'}
            variant="outlined"
            value="moveUp"
            onClick={handleObjectButtonClick}
            disabled={flipToFrontDisabled}
          >
            <Tooltip title={t('objectTools.moveUp')}>
              <ToFrontIcon />
            </Tooltip>
          </Button>
        </AnalyticsWrapper>
      </React.Fragment>
    );
  }
}

export default withWidth()(withStyles(styles, { name: 'ObjectTools' })(ObjectTools));
